export const CREATE_PSEUDONYM_FAILURE = 'CREATE_PSEUDONYM_FAILURE';

export const createPseudonymFailure = error => ({
    type: CREATE_PSEUDONYM_FAILURE,
    payload: error,
    error: true,
});
